import React from "react";
import Container from "../components/Layouts/Container";
import Blog from "../components/Blog/Blog";

const BlogPage = () => {
  return (
    <Container>
      <Blog />
    </Container>
  );
};

export default BlogPage;
